import moment from 'moment';

export const isTodayOnOrAfter = (cutOverDate = '') => {
    return moment.utc().isSameOrAfter(moment.utc(cutOverDate));
};
